// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__11VYd","radioRow":"SimpleQuestionBuilderModal_radioRow__-zAAd"};